// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"e502ced4","787":"1f8e4194"}[chunkId] + ".chunk.js";
};